<template>
  <v-container fill-height fluid>
    <v-row justify="center" align="center">
      <v-col sm="5">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <form @submit.prevent="submit" class="pa-6">
            <v-row>
              <v-col>
                <p class="text-h5">
                  Nombre del centro
                </p>
                <ValidationProvider
                  name="Nombre del centro"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    id="name"
                    name="name"
                    label="Nombre del centro"
                    v-model="currentUser.displayName"
                    :error="errors.length > 0"
                    :error-messages="errors[0]"
                    autocomplete="off"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <p class="text-h5">
              Persona de contacto
            </p>
            <v-row>
              <v-col>
                <ValidationProvider
                  name="Contacto"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    id="contact"
                    name="contact"
                    type="contact"
                    label="Nombre persona de contacto"
                    v-model="currentUser.contact"
                    :error="errors.length > 0"
                    :error-messages="errors[0]"
                    autocomplete="off"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-btn color="primary" type="submit">Guardar información</v-btn>
            </v-row>

            <v-row justify="center" class="mt-10"> </v-row>
            <v-row justify="center" class="mt-10"> </v-row>
            <v-row justify="center" class="mt-10"> </v-row>

            <p class="text-h5 text-center">
              Eliminar cuenta del sistema
            </p>
            <v-row justify="center" class="mt-5">
              <v-btn @click="deleteConfirmation" color="red"
                >Eliminar cuenta</v-btn
              >
            </v-row>
          </form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <ErrorMessage />
    <CustomDialog ref="confirmationDialog"></CustomDialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackBarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="green" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import CustomDialog from '@/components/common/CustomDialog'

export default {
  data: () => ({
    modal: false,
    timeout: 2000,
    snackBarText: null,
    snackbar: false
  }),

  components: {
    CustomDialog
  },

  computed: {
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('currentUser', ['currentUser'])
  },

  methods: {
    ...mapActions('authentication', ['deleteAccount']),
    async submit() {
      this.updateUser()
    },
    async deleteConfirmation() {
      this.$refs.confirmationDialog.show(
        'warning',
        `¿Está seguro que desea eliminar la cuenta? Esta acción eliminará toda la información`,
        true,
        this.deleteAccount
      )
    },
    async updateUser() {
      const done = this.$store.dispatch('currentUser/set', this.currentUser)

      console.log(done)
      this.snackBarText = 'Información actualizada'
      this.snackbar = true
    }
  }
}
</script>
